var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { Alert, Toast, ToastContainer } from "react-bootstrap";
import Errormsg from "./errorMsg";
import ConfirmationPopup from "./ConfirmationPopup/ConfirmationPopup";
// import { RootState } from "@redux/reducers/rootState";
// import Drawer from "react-bottom-drawer";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { useNavigate } from "react-router-dom";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
export var ErrorDisplayType;
(function (ErrorDisplayType) {
    ErrorDisplayType["ALERT"] = "alert";
    ErrorDisplayType["POPUP"] = "popup";
    ErrorDisplayType["TOAST"] = "toast";
    ErrorDisplayType["INSECTION"] = "inSection";
    ErrorDisplayType["NONE"] = "none";
})(ErrorDisplayType || (ErrorDisplayType = {}));
var ErrorNotification = function (props) {
    var _a, _b, _c, _d, _e;
    var device = DeviceContext();
    var _f = __read(useState(props.displayType), 2), displayType = _f[0], setDisplayType = _f[1];
    var navigate = useNavigate();
    var _g = __read(useState(""), 2), modalTitle = _g[0], setModalTitle = _g[1];
    var _h = __read(useState(null), 2), popupUI = _h[0], setPopupUI = _h[1];
    function handleClose() {
        props.onClose();
    }
    var redirect = function () {
        console.log("props", props);
        props === null || props === void 0 ? void 0 : props.redirect;
        props.refresh();
        // navigate("/login");
        // localStorage.setItem("revampSessionExpired", "true");
        // localStorage.setItem("redirectUrl", window.location.toString());
        // EMTReportCallBack(
        //   AccountDetails.lgnSrc as LoginSource,
        //   ThirdPartyCallBack.SessionExpire
        // );
        // window.location.href = config.oldWebUrl;
    };
    var unAuthorizeError = function () {
        return (React.createElement("div", null,
            React.createElement("p", null, "Your Session is Expired. Please login again."),
            React.createElement(EdButton, { type: "button", className: "login-btn", onClick: function () { return redirect(); }, value: "Login", btnTyp: "blue-one" })));
    };
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.error) && (props === null || props === void 0 ? void 0 : props.isOpen)) {
            switch (props.error.getHttpCode()) {
                case 401:
                case 403:
                    setModalTitle("Session Expired!");
                    setPopupUI(unAuthorizeError());
                    setDisplayType(ErrorDisplayType.POPUP);
            }
        }
    }, []);
    switch (displayType) {
        case ErrorDisplayType.ALERT:
            return (React.createElement("div", { id: "error" }, props.error && (React.createElement(Alert
            // show={isOpen}
            , { 
                // show={isOpen}
                key: "danger", variant: "danger", onClose: handleClose, dismissible: true, style: { display: props.isOpen ? "block" : "none" } },
                React.createElement(Alert.Heading, null, "Oh snap! You got an error!"),
                React.createElement("span", null, (_a = props === null || props === void 0 ? void 0 : props.error) === null || _a === void 0 ? void 0 : _a.getErrorMessege())))));
        case ErrorDisplayType.POPUP:
            return (React.createElement(React.Fragment, null, props.isOpen && props.error && (React.createElement("div", { id: "error" }, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(ConfirmationPopup, { show: true, popTitle: modalTitle, showFooter: false, popupClass: "withShadow" }, popupUI)) : (React.createElement(React.Fragment, null)
            // <Drawer
            //   duration={250}
            //   hideScrollbars={true}
            //   className="error_wrapper"
            //   isVisible={true}
            //   onClose={() => {}}
            // >
            //   {popupUI}
            // </Drawer>
            )))));
        case ErrorDisplayType.TOAST:
            return (React.createElement("div", { id: "error" }, props.error && (React.createElement(ToastContainer, { className: "p-3", position: "top-end", style: { zIndex: "9999" } },
                React.createElement(Toast, { onClose: handleClose, bg: "danger", style: { display: props.isOpen ? "block" : "none" } },
                    React.createElement(Toast.Header, null,
                        React.createElement("img", { src: "", className: "rounded me-2", alt: "" }),
                        React.createElement("strong", { className: "me-auto" }, props.headerTitle ? props.headerTitle : "Error"),
                        React.createElement("small", null, "1 mins ago")),
                    React.createElement(Toast.Body, null, (_b = props.error) === null || _b === void 0 ? void 0 : _b.getErrorMessege()))))));
        case ErrorDisplayType.INSECTION:
            return (React.createElement(React.Fragment, null, props.isOpen && props.error && (React.createElement("div", { id: "error" },
                React.createElement(Errormsg, { msg: ((_c = props === null || props === void 0 ? void 0 : props.error) === null || _c === void 0 ? void 0 : _c.getHttpCode()) === 400 || 500
                        ? (_d = props === null || props === void 0 ? void 0 : props.error) === null || _d === void 0 ? void 0 : _d.getErrorMessege()
                        : "Oops! Looks like one of those days, we have run <br/> into some technical difficulties. Please refresh", refresh: props.refresh ? true : false, refreshFunc: props.refresh, image: props.image, customComp: props.customComp })))));
        case ErrorDisplayType.NONE:
            return React.createElement(React.Fragment, null);
        default:
            return (React.createElement("div", { id: "error" }, props.error && (React.createElement(Alert
            // show={isOpen}
            , { 
                // show={isOpen}
                key: "danger", variant: "danger", onClose: handleClose, dismissible: true, style: { display: props.isOpen ? "block" : "none" } },
                React.createElement(Alert.Heading, null, "Oh snap! You got an error!"),
                React.createElement("span", null, (_e = props === null || props === void 0 ? void 0 : props.error) === null || _e === void 0 ? void 0 : _e.getErrorMessege())))));
    }
};
export default ErrorNotification;
